import { createSlice } from "@reduxjs/toolkit";

export const ActiveEstateList = createSlice({
    name: "activeEstateList",
    initialState: {
        activeEstateList: [],
    },
    reducers: {
        setActiveEstateList: (state, action) => {
            state.activeEstateList = action.payload;
        },
        clearActiveEstateList: (state, action) => {
            state.activeEstateList = [];
        }
    }
})

export const { setActiveEstateList, clearActiveEstateList } = ActiveEstateList.actions;

export default ActiveEstateList.reducer;




